import { getRuleErrorMessage } from "@/utils/formHelper";

import { I_QREditorFormTemplate } from "@/data/types/pages";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrFeedbackValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "feedbackTitle",
      rules: {
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("feedbackTitle", "maxLength", data),
        },
      },
    },
    {
      name: "feedbackSubtitle",
      rules: {
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("feedbackSubtitle", "maxLength", data),
        },
      },
    },
    {
      name: "categoryName",
      rules: {
        require: {
          message: getRuleErrorMessage("categoryName", "required", data),
        },
        maxLength: {
          value: 200,
          message: getRuleErrorMessage("categoryName", "maxLength", data),
        },
      },
    },
  ];
};
